import { useAppSelector } from 'app/hooks';
import { useMemo } from 'react';
import { isFootprintFullyCovered } from 'utils/footprint-coverage';
import { isFootprintCoverageBlockingNewSpaces } from 'utils/hybrid-space-palette';
import { resolveNewSpaceGate } from 'utils/new-space-gate';
import { NewSpaceGate } from 'utils/new-space-gate-types';
import { isHybridOnlySystemPreference } from 'utils/project';
import { isLevelConditioned } from 'utils/structure';

export function useNewSpaceGate(): NewSpaceGate {
  const { estimatingStructure, activeLevelIndex } = useAppSelector(
    (state) => state.ui
  );
  const { structure } = useAppSelector((state) => state.structure);
  const { arrangingLoading } = useAppSelector((state) => state.ai);
  const isHybrid = useAppSelector((state) =>
    isHybridOnlySystemPreference(
      state.project.projectSettings.find(
        (ps) => ps.code === 'system_preference'
      )?.value
    )
  );

  const currentLevel = structure[activeLevelIndex];
  const ceilingHeightAttribute = currentLevel?.attributes.find(
    (att) => att.code === 'ceiling_height'
  );
  const hasCeilingHeight =
    ceilingHeightAttribute?.value != null &&
    ceilingHeightAttribute.value !== '';
  const isConditioned = isLevelConditioned(currentLevel ?? null);
  const loading = estimatingStructure || arrangingLoading;
  const isFloorFullyCovered = useMemo(
    () =>
      isFootprintCoverageBlockingNewSpaces(
        isHybrid,
        isFootprintFullyCovered(currentLevel)
      ),
    [currentLevel, isHybrid]
  );

  return useMemo(
    () =>
      resolveNewSpaceGate({
        loading,
        isConditioned,
        hasCeilingHeight,
        isFloorFullyCovered
      }),
    [loading, isConditioned, hasCeilingHeight, isFloorFullyCovered]
  );
}
